import BenchlingConfig from 'BenchlingConfig';
import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Context available for determining whether to show submenu items
 */
export interface SubmenuContext {
  itemType: TagSchemaItemType | null;
}

/**
 * A simple predicate function that determines if a submenu should be shown
 */
export type SubmenuPredicate = (context: SubmenuContext) => boolean;

/**
 * Helper to check if a schema is an antibody schema
 */
export function isAntibodySchema(context: SubmenuContext): boolean {
  return context.itemType === TagSchemaItemType.ANTIBODY;
}

/**
 * Predicate for showing antibody domains submenu
 * Shows for antibody schemas
 */
export function shouldShowAntibodyDomains(context: SubmenuContext): boolean {
  return isAntibodySchema(context);
}

/**
 * Predicate for showing antibody chains submenu
 * Shows for antibody schemas
 */
export function shouldShowAntibodyChains(context: SubmenuContext): boolean {
  return isAntibodySchema(context);
}

/**
 * Predicate for showing chemistry name parts submenu
 * Shows for molecule schemas
 *
 * Keep in sync with benchling/chemistry/name_templates/salt_codes_name_template_part_definition.py is_valid_name_part_type_for_item
 */
export function shouldShowChemistryNameParts(context: SubmenuContext): boolean {
  return (
    BenchlingConfig.CHEMISTRY_ENABLE_STOICHIOMETRY_TABLE && context.itemType === TagSchemaItemType.MOLECULE
  );
}

/**
 * Helper function to conditionally include submenus based on context
 */
export function conditionalSubmenu(
  submenu: {
    sectionHeader: string;
    namePartTypes: Array<import('graphql-client/__generated/graphqlGlobalTypes').NameTemplatePartType>;
  },
  predicate: SubmenuPredicate,
  context: SubmenuContext
): Array<typeof submenu> {
  return predicate(context) ? [submenu] : [];
}
